import React, { useEffect } from "react";
import { Grid, Box, Typography, Button } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { TbBookmark } from "react-icons/tb";
import { CANDIDATES_API } from "../api";
import { updateSearchResults, addNewMessage } from "../slice";
import moreIcon from "../assets/icons/more.png";
import { ReactComponent as CalendarAlt } from "../assets/icons/calendar-alt.svg";
import { ReactComponent as LocationMark } from "../assets/icons/LocationMark.svg";
import { ReactComponent as CommitmentRate } from "../assets/icons/CommitmentRate.svg";
import { ReactComponent as FileLandScapeAlt } from "../assets/icons/file-landscape-alt.svg";

function SearchItem({
  number,
  residenceCityName,
  commitmentRateName,
  birthDate,
  educationDegree,
  isCandidate = false,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { mutate: addCandidate } = useMutation(
    (candidateProfileNumber) => CANDIDATES_API.AddCandidate(candidateProfileNumber),
    {
      onSuccess: () => dispatch(updateSearchResults({ number, isCandidate: true })),
      onError: ({ response: { data } }) =>
        dispatch(
          addNewMessage({
            id: "failed-on-bookmark",
            text: data.message,
            type: "error",
          })
        ),
    }
  );

  const { mutate: unBookmarkProfileCandidate } = useMutation(
    (candidateProfileNumber) => CANDIDATES_API.UnBookmarkProfileCandidate(candidateProfileNumber),
    {
      onSuccess: () => dispatch(updateSearchResults({ number, isCandidate: false })),
      onError: ({ response: { data } }) =>
        dispatch(
          addNewMessage({
            id: "failed-on-bookmark",
            text: data.message,
            type: "error",
          })
        ),
    }
  );

  const handleCandidateBookmark = (candidateProfileNumber) => {
    if (isCandidate) {
      unBookmarkProfileCandidate(candidateProfileNumber);
    } else {
      addCandidate(candidateProfileNumber);
    }
  };

  useEffect(() => {
    dispatch(updateSearchResults({ number, isCandidate }));
  }, [isCandidate, dispatch]);

  return (
    <Box
      borderRadius={3}
      my={2}
      overflow="hidden"
      sx={{ backgroundColor: "#F6F6F6" }}
      py={2}
      px={1}
    >
      <Grid
        container
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        width="100%"
        mb={1}
        sx={{ flex: 1 }}
      >
        <Button
          variant="s2"
          startIcon={<img src={moreIcon} alt="" />}
          onClick={() => navigate(`/candidate-details/${number}`)}
          sx={{ backgroundColor: "transparent" }}
        >
          اطلاعات بیشتر
        </Button>
        <Box display="flex">
          <Typography variant="h2" textAlign="right" mt={1}>
            {number}
          </Typography>
          <Button onClick={() => handleCandidateBookmark(number)}>
            <TbBookmark
              color="#4C466F"
              style={{ fill: isCandidate ? "#4C466F" : "transparent" }}
              fontSize="25px"
            />
          </Button>
        </Box>
      </Grid>
      <Grid container flexDirection="row-reverse" alignItems="stretch">
        <Grid item p={1} xs={6} sm={6} md={3} minWidth="120px">
          <Box
            display="flex"
            justifyContent="flex-start"
            alignItems="center"
            flexDirection="row-reverse"
            sx={{ boxSizing: "border-box" }}
            px={1}
            py={2}
            width="100%"
            bgcolor="#E8E8E8"
            borderRadius={2}
          >
            <CalendarAlt style={{ minWidth: "1.1rem", minHeight: "1.1rem" }} />
            <Typography variant="h2" noWrap marginRight="0.5rem">
              {birthDate}
            </Typography>
          </Box>
        </Grid>
        <Grid item p={1} xs={6} sm={6} md={3} minWidth="120px">
          <Box
            display="flex"
            flexDirection="row-reverse"
            justifyContent="flex-start"
            alignItems="center"
            sx={{ boxSizing: "border-box" }}
            px={1}
            py={2}
            width="100%"
            bgcolor="#E8E8E8"
            borderRadius={2}
          >
            <FileLandScapeAlt />
            <Typography variant="h2" noWrap marginRight="0.5rem">
              {educationDegree.map((degree) => degree)}
            </Typography>
          </Box>
        </Grid>
        <Grid item p={1} xs={6} sm={6} md={3} minWidth="120px">
          <Box
            display="flex"
            flexDirection="row-reverse"
            justifyContent="flex-start"
            alignItems="center"
            sx={{ boxSizing: "border-box" }}
            px={1}
            py={2}
            width="100%"
            bgcolor="#E8E8E8"
            borderRadius={2}
          >
            <LocationMark />
            <Typography variant="h2" noWrap marginRight="0.5rem">
              {residenceCityName}
            </Typography>
          </Box>
        </Grid>
        <Grid item p={1} xs={6} sm={6} md={3} minWidth="120px">
          <Box
            display="flex"
            flexDirection="row-reverse"
            justifyContent="flex-start"
            alignItems="center"
            sx={{ boxSizing: "border-box" }}
            px={1}
            py={2}
            width="100%"
            bgcolor="#E8E8E8"
            borderRadius={2}
          >
            <CommitmentRate style={{ minWidth: "1.1rem", minHeight: "1.1rem" }} />
            <Typography variant="h2" noWrap marginRight="0.5rem">
              {commitmentRateName}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default SearchItem;
